// import $ from 'jquery';

export default class FixTranslate {
  constructor(element) {
    this.element = element;
    this.process();
  }

  process() {
    const head = this.element.contentWindow.document.querySelector('html head');
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = 'https://www.altaregional.org/sites/default/files/theme/dtheme-direct.css';
    head.appendChild(link);
  }
}
